import http from '../http'

/** 工作汇总接口保持业务记录只读，仅提交补充内容和汇总状态。 */
export const fetchMyWorkReports = () => http.get('/work-reports/my')

export const fetchWorkReport = (date) => http.get(`/work-reports/${date}`)

export const fetchWorkReportById = (reportId) => http.get(`/work-reports/id/${reportId}`)

export const saveWorkReportDraft = (date, payload) => http.put(`/work-reports/${date}/draft`, payload)

export const submitWorkReport = (date) => http.post(`/work-reports/${date}/submit`)

export const withdrawWorkReport = (reportId) => http.post(`/work-reports/${reportId}/withdraw`)

export const fetchWorkReportReviews = () => http.get('/work-reports/reviews')

export const addWorkReportComment = (reportId, payload) => http.post(`/work-reports/${reportId}/comments`, payload)

export const batchReadWorkReports = (reportIds) => http.post('/work-reports/reviews/batch-read', {reportIds})

/** 日报图片与周报保持相同格式和数量限制，实际校验以服务端为准。 */
export const uploadWorkReportImage = (date, file) => {
  const form = new FormData()
  form.append('file', file)
  return http.post(`/work-reports/${date}/images/upload`, form, {headers: {'Content-Type': 'multipart/form-data'}})
}

export const deleteWorkReportImage = (attachmentId) => http.post(`/work-reports/images/${attachmentId}/delete`)

export const workReportImagePreviewUrl = (reportId, attachmentId) =>
  `/api/work-reports/${reportId}/images/${attachmentId}/preview`

export const fetchWeeklyWorkReport = (weekStart) => http.get('/work-reports/weekly', {params: {weekStart}})

/** 可提交周报使用独立接口，不改变既有动态周汇总契约。 */
export const fetchWeeklyReportDetail = (weekStart) => http.get(`/work-reports/weekly-reports/${weekStart}`)

export const fetchWeeklyReportById = (weeklyReportId) => http.get(`/work-reports/weekly-reports/id/${weeklyReportId}`)

export const saveWeeklyReportDraft = (weekStart, payload) => http.put(`/work-reports/weekly-reports/${weekStart}/draft`, payload)

export const submitWeeklyReport = (weekStart) => http.post(`/work-reports/weekly-reports/${weekStart}/submit`)

export const withdrawWeeklyReport = (weeklyReportId) => http.post(`/work-reports/weekly-reports/${weeklyReportId}/withdraw`)

export const fetchWeeklyReportReviews = () => http.get('/work-reports/weekly-reports/reviews')

export const addWeeklyReportComment = (weeklyReportId, payload) => http.post(`/work-reports/weekly-reports/${weeklyReportId}/comments`, payload)

export const batchReadWeeklyReports = (reportIds) => http.post('/work-reports/weekly-reports/reviews/batch-read', {reportIds})

export const uploadWeeklyReportImage = (weekStart, file) => {
  const form = new FormData()
  form.append('file', file)
  return http.post(`/work-reports/weekly-reports/${weekStart}/images/upload`, form, {headers: {'Content-Type': 'multipart/form-data'}})
}

export const deleteWeeklyReportImage = (attachmentId) => http.post(`/work-reports/weekly-reports/images/${attachmentId}/delete`)

export const weeklyReportImagePreviewUrl = (weeklyReportId, attachmentId) =>
  `/api/work-reports/weekly-reports/${weeklyReportId}/images/${attachmentId}/preview`

export const fetchWorkReportRelations = () => http.get('/work-reports/relations')

export const saveWorkReportRelations = (assignments) => http.put('/work-reports/relations', {assignments})
